import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListAlt } from '@fortawesome/free-solid-svg-icons';
import InternalShell, { useInternalApi } from '../layouts/InternalShell';
import { FINANCE_NAV } from './nav';

interface Event { kind: string; ref: string; amount: number; when: string; detail: string; }

const KIND_COLORS: Record<string, string> = { invoice_payment: 'success', gateway_payment: 'info', gateway_deposit: 'primary', gateway_refund: 'warning', refund: 'danger' };

const FinancialAuditTrail: React.FC = () => {
    const { api } = useInternalApi();
    const [events, setEvents] = useState<Event[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => { document.title = 'Financial Audit Trail - Uzima Internal'; }, []);
    useEffect(() => {
        api.get('admin-dashboard/finance/audit-trail/').then(res => {
            if (res.data?.status === 'success') setEvents(res.data.data || []);
        }).finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <InternalShell activeDashboard="finance_center" subNav={FINANCE_NAV}>
            <h2 className="fw-bold mb-1"><FontAwesomeIcon icon={faListAlt} className="me-2 text-primary" />Financial Audit Trail</h2>
            <p className="text-muted mb-4">A single chronological ledger across invoice payments, gateway transactions and refunds</p>

            <div className="card border-0 shadow-sm">
                <div className="card-body p-0">
                    {loading ? (
                        <div className="text-center py-5"><div className="spinner-border text-primary" role="status"><span className="visually-hidden">Loading...</span></div></div>
                    ) : events.length === 0 ? (
                        <div className="text-center py-5 text-muted">No financial events recorded yet.</div>
                    ) : (
                        <table className="table table-hover align-middle mb-0">
                            <thead className="table-light"><tr><th>Kind</th><th>Reference</th><th>Amount</th><th>Detail</th><th>When</th></tr></thead>
                            <tbody>
                                {events.map((e, i) => (
                                    <tr key={i}>
                                        <td><span className={`badge bg-${KIND_COLORS[e.kind] || 'secondary'}`}>{e.kind.replace('_', ' ')}</span></td>
                                        <td>{e.ref}</td>
                                        <td className={e.amount < 0 ? 'text-danger' : ''}>{e.amount.toLocaleString()}</td>
                                        <td className="small">{e.detail}</td>
                                        <td>{new Date(e.when).toLocaleString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </InternalShell>
    );
};

export default FinancialAuditTrail;
